'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagSyAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 5.06639e-07 20C5.06639e-07 13.3333 3.77204e-06 6.66667 0 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.06639e-07 20H28V13.3333H5.06639e-07V20Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.06639e-07 6.66667H28V0H0L5.06639e-07 6.66667Z",
          fill: "#E32139"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.33317 11.0933L7.76574 12.1574L8.29335 10.3378L6.79702 9.17594L8.69053 9.11546L9.33317 7.33331L9.97582 9.11546L11.8693 9.17594L10.373 10.3378L10.9006 12.1574L9.33317 11.0933Z",
          fill: "#128A49"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.6667 11.0933L17.0992 12.1574L17.6268 10.3379L16.1305 9.17596L18.024 9.11548L18.6667 7.33333L19.3093 9.11548L21.2028 9.17596L19.7065 10.3379L20.2341 12.1574L18.6667 11.0933Z",
          fill: "#128A49"
        }
      )
    ]
  }
);
const VpFlagSyAsset = forwardRef(FlagSyAsset);

export { VpFlagSyAsset as default };
